
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import  themen  from 'theme/styles/styled-colors';
import  * as theme  from 'react-syntax-highlighter/dist/esm/styles/hljs';
import SyntaxHighlighter from 'react-syntax-highlighter';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "overview"
    }}>{`Overview`}</h1>
    <p>{`This project uses a Source Content Management System to manage its source code.`}</p>
    <h1 {...{
      "id": "web-access"
    }}>{`Web Access`}</h1>
    <p>{`The following is a link to the online source repository.
`}<a parentName="p" {...{
        "href": "https://github.com/apache/atlas.git"
      }}>{`https://github.com/apache/atlas.git`}</a></p>
    <h1 {...{
      "id": "anonymous-access"
    }}>{`Anonymous access`}</h1>
    <p>{`Refer to the documentation of the SCM used for more information about anonymously check out.`}<br />{` The connection url is:
git://git.apache.org/atlas.git`}</p>
    <h1 {...{
      "id": "developer-access"
    }}>{`Developer access`}</h1>
    <p>{`Refer to the documentation of the SCM used for more information about developer check out.`}<br />{` The connection url is: `}<a parentName="p" {...{
        "href": "https://gitbox.apache.org/repos/asf/atlas.git"
      }}>{`https://gitbox.apache.org/repos/asf/atlas.git`}</a></p>
    <h1 {...{
      "id": "access-from-behind-a-firewall"
    }}>{`Access from behind a firewall`}</h1>
    <p>{`Refer to the documentation of the SCM used for more information about access behind a firewall.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;